import { useEffect, useState } from "react";

function pad(n) {
  return String(n).padStart(2, "0");
}

export function Countdown({ deadline, light = false }) {
  const [left, setLeft] = useState(null);

  useEffect(() => {
    if (!deadline) return;
    const target = new Date(deadline).getTime();
    const tick = () => {
      const diff = target - Date.now();
      if (diff <= 0) {
        setLeft({ d: 0, h: 0, m: 0, s: 0, ended: true });
        return;
      }
      setLeft({
        d: Math.floor(diff / 86400000),
        h: Math.floor((diff / 3600000) % 24),
        m: Math.floor((diff / 60000) % 60),
        s: Math.floor((diff / 1000) % 60),
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [deadline]);

  const c = light ? "text-cream" : "text-charcoal";
  const sub = light ? "text-cream/50" : "text-charcoal/40";

  if (!left) return null;
  if (left.ended)
    return <span className={`font-display font-semibold ${c}`}>Submissions closed</span>;

  const units = [
    { v: left.d, l: "Days" },
    { v: left.h, l: "Hrs" },
    { v: left.m, l: "Min" },
    { v: left.s, l: "Sec" },
  ];

  return (
    <div data-testid="countdown" className="flex items-end gap-3 md:gap-4">
      {units.map((u, i) => (
        <div key={i} className="text-center">
          <div className={`font-mono text-2xl md:text-3xl font-bold tabular-nums ${c}`}>{pad(u.v)}</div>
          <div className={`text-[10px] uppercase tracking-widest ${sub}`}>{u.l}</div>
        </div>
      ))}
    </div>
  );
}
